// apps/admin-ui/src/routes/_authenticated/coin-transactions/index.tsx
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '../../../features/auth/auth-context';
import {
  type CoinTransactionsListFilters,
  listCoinTransactionsOptions,
} from '../../../features/coin-transactions/api';
import { AdjustCoinsDialog } from '../../../features/coin-transactions/components/adjust-coins-dialog';
import { CoinTransactionsFilters } from '../../../features/coin-transactions/filters';
import { CoinTransactionsTable } from '../../../features/coin-transactions/table';
import { PageHeader } from '../../../shared/components/page-header';
import { Route as CoinTransactionsRoute } from './route';

function toFilters(search: ReturnType<typeof CoinTransactionsRoute.useSearch>): CoinTransactionsListFilters {
  const out: CoinTransactionsListFilters = { limit: search.limit };
  if (search.cursor !== undefined) out.cursor = search.cursor;
  if (search.status?.length) out.status = search.status;
  if (search.reason?.length) out.reason = search.reason;
  if (search.userId !== undefined) out.userId = search.userId;
  return out;
}

export const Route = createFileRoute('/_authenticated/coin-transactions/')({
  loaderDeps: ({ search }) => ({
    cursor: search.cursor,
    limit: search.limit,
    status: search.status,
    reason: search.reason,
    userId: search.userId,
  }),
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(listCoinTransactionsOptions(toFilters(deps)));
  },
  component: CoinTransactionsIndexPage,
});

function CoinTransactionsIndexPage() {
  const search = CoinTransactionsRoute.useSearch();
  const { data: page } = useSuspenseQuery(listCoinTransactionsOptions(toFilters(search)));
  const { adminRoles } = useAuth();

  return (
    <div>
      <PageHeader
        title="Энергия — транзакции"
        description="Журнал начислений, корректировок и списаний внутренней валюты."
        actions={adminRoles.includes('SUPERADMIN') ? <AdjustCoinsDialog /> : undefined}
      />
      <CoinTransactionsFilters
        value={{
          status: search.status,
          reason: search.reason,
          userId: search.userId,
        }}
      />
      <CoinTransactionsTable
        items={page.items}
        nextCursor={page.nextCursor}
        currentCursor={search.cursor}
        currentSearch={{
          status: search.status,
          reason: search.reason,
          userId: search.userId,
          cursor: search.cursor,
          limit: search.limit,
        }}
      />
    </div>
  );
}
